module.exports = __webpack_public_path__ + "img/logo_white.91fdec98.png";